// extracted by mini-css-extract-plugin
module.exports = {"footer":"choose-frequency-later-payment-footer_footer__Thdqh","footerPaywall":"choose-frequency-later-payment-footer_footerPaywall__NJheX"};